module.exports = __webpack_public_path__ + "static/media/repdemcongo.fb393db8.jpg";